import { useState, useEffect, lazy, Suspense } from 'react'
import { TERMINAL_DURATION } from './config/constants'
const Terminal = lazy(() => import('./components/Terminal'))
const weddingImport = () => import('./components/Wedding')
const Wedding = lazy(weddingImport)

const WEDDING_PRELOAD_IMAGES = [
  '/images/7779C7AB-08E7-418D-A65E-4B9044FFF83B 1.webp',
  '/images/E0CD8420-5D29-4105-B5E9-8E297983E144 1.webp',
  '/images/E3317F99-3D03-4129-87F7-5FDAF8533A51 1.webp',
  '/images/D67B5A4E-5F76-4638-AE65-33B68710D32B 1.webp',
  '/images/Rectangle_288_209.webp',
  '/images/Vector_261_13.webp',
  '/images/Rectangle_261_110.webp',
  '/images/Rectangle_261_22.webp',
  '/images/Rectangle_261_12.webp',
  '/images/Vector_261_17.webp',
  '/images/Vector_261_18.webp',
  '/images/Vector_261_23.webp',
]

const WEDDING_PRELOAD_FONTS = [
  { href: '/fonts/Jost_wght__1.ttf', type: 'font/ttf' },
  { href: '/fonts/DrukTextWideSuperTrial.otf', type: 'font/otf' },
  { href: '/fonts/druktextwidecyr-bold.otf', type: 'font/otf' },
]

function LoadingFallback() {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#001029',
      }}
      aria-live="polite"
    >
      <span style={{ color: '#2BDE9D', fontFamily: 'monospace' }}>Loading...</span>
    </div>
  )
}

export default function App() {
  const [view, setView] = useState('terminal')

  useEffect(() => {
    weddingImport()
    WEDDING_PRELOAD_IMAGES.forEach((src) => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'image'
      link.href = src
      document.head.appendChild(link)
    })
    WEDDING_PRELOAD_FONTS.forEach(({ href, type }) => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'font'
      link.type = type
      link.href = href
      link.crossOrigin = 'anonymous'
      document.head.appendChild(link)
    })
  }, [])

  useEffect(() => {
    if (view !== 'terminal') return

    const timer = setTimeout(() => setView('wedding'), TERMINAL_DURATION)
    return () => clearTimeout(timer)
  }, [view])

  return (
    <Suspense fallback={<LoadingFallback />}>
      {view === 'wedding' && <Wedding />}
      {view === 'terminal' && <Terminal />}
    </Suspense>
  )
}
